import React, { useState } from "react";
import Dashboard from "components/dashboard";
import { PageSection, PageHeaderBar } from "components/page";
import { ActionButtons, SearchForm } from "./list-page";
import ContractPaginatedTable from "./table";

const ContractListPage = () => {
  const [deploymentIdForContractFilter, setDeploymentIdForContractFilter] = useState(null);
  const [contractNameForContractFilter, setContractNameForContractFilter] = useState();

  return (
    <Dashboard>
      <PageHeaderBar title="app.page.contract.list" buttons={<ActionButtons />} />
      <PageSection spaced>
        <SearchForm
          deploymentId={deploymentIdForContractFilter}
          setDeploymentId={setDeploymentIdForContractFilter}
          contractName={contractNameForContractFilter}
          setContractName={setContractNameForContractFilter}
        />
      </PageSection>
      <PageSection spaced hideBackground>
        <ContractPaginatedTable
          contractName={contractNameForContractFilter}
          deploymentId={deploymentIdForContractFilter}
        />
      </PageSection>
    </Dashboard>
  );
};

export default ContractListPage;
